export enum KnmDraftTypesEnum {
  KNM_PM = 'KNM_PM',
  DECISION_PASSPORT = 'DECISION_PASSPORT',
}
